<template>
  <frontoffice-frame :padding-content="false">
    <frontoffice-loader v-if="isLoading" class="loader-section" />

    <b-container v-if="!isLoading" id="page"
                 class="front-layout booking-unlogged"
    >
      <headbar class="headbar" :logo="logo" />

      <b-row class="booking-group-prelogged row justify-content-center">
        <div class="col-12 col-md-8">
          <page-title>
            {{ $t('_generic_request') }}
          </page-title>

          <ul class="row justify-content-around companyPrelogged-links">
            <li class="col-8">
              <router-link :to="newAccountRoute" class="btn orange-white">
                {{ $t('_create_account') |capitalize }}
              </router-link>
            </li>

            <li class="col-8">
              <router-link v-if="company.offlineEnabled" :to="offlineFormRoute"
                           class="btn orange-white"
              >
                {{ $t('_offline') }}
              </router-link>
            </li>
          </ul>
        </div>
      </b-row>
    </b-container>
  </frontoffice-frame>
</template>

<script>
import headbar from '@/components/frontoffice/header'
import frontofficeFrame from '@/components/frontoffice/frame'
import frontofficeLoader from '@/components/frontoffice/loader'
import pageTitle from '@/components/frontoffice/pageTitle'
import OfflineBookingForm from '@/components/frontoffice/OfflineBooking/OfflineBookingForm'
import CommonApi from '@/api/commonApi'

export default {
  components: {
    headbar,
    frontofficeFrame,
    frontofficeLoader,
    pageTitle,
    OfflineBookingForm
  },

  data () {
    return {
      commonApi: new CommonApi(),
      isLoading: true,
      companyUid: this.$route.params.companyUid,
      company: {}
    }
  },

  created () {
    // HACK BEFORE CLIENT VALIDATE FUNCTIONALITY IN V2
    this.$router.push(this.newAccountRoute)

    this.commonApi.getGenericCompanyData(this.companyUid)
      .then(response => {
        if (response.data.success) {
          this.isLoading = false
          this.company = response.data.data
        }
      })
  },

  computed: {
    logo () {
      return this.company.logo_image
    },

    name () {
      return this.company.name
    },

    newAccountRoute () {
      return {
        name: 'create_account',
        params: { companyUid: this.companyUid }
      }
    },

    offlineFormRoute () {
      return {
        name: 'offline_booking_generic_company',
        params: { companyUid: this.companyUid }
      }
    }
  }
}
</script>

<style lang="scss">
  @import '@/assets/sass/booking_unlogged.scss';
</style>
